export default __webpack_public_path__ + "static/media/hamburger.4fff6c1f.svg";